import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/roomEntrance/starGift',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-roomEntrance-starGift" */ '~/pages/RoomEntrance/pages/StarGift'
        )
    ),
  },
  {
    path: '/roomEntrance/SmallRoket',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-roomEntrance-SmallRoket" */ '~/pages/RoomEntrance/pages/SmallRoket'
        )
    ),
  },
] as RouteConfig[]
